var AssessmentGroup = /** @class */ (function () {
    function AssessmentGroup() {
        this.assessments = [];
        this.created = new Date();
        this.updated = new Date();
    }
    Object.defineProperty(AssessmentGroup.prototype, "Id", {
        get: function () {
            return this.id;
        },
        set: function (v) {
            this.id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentGroup.prototype, "Name", {
        get: function () {
            return this.name;
        },
        set: function (v) {
            this.name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentGroup.prototype, "Assessments", {
        get: function () {
            return this.assessments;
        },
        set: function (v) {
            this.assessments = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentGroup.prototype, "Created", {
        get: function () {
            return this.created;
        },
        set: function (v) {
            this.created = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentGroup.prototype, "Updated", {
        get: function () {
            return this.updated;
        },
        set: function (v) {
            this.updated = v;
        },
        enumerable: true,
        configurable: true
    });
    return AssessmentGroup;
}());
export { AssessmentGroup };



// WEBPACK FOOTER //
// ./src/app/shared/models/assessment-group.ts.pre-build-optimizer.js